import type { NodeStyle } from "../Graph.model";

const hiddenNodeStyle: Partial<NodeStyle> = {
  visible: false,
};

export default hiddenNodeStyle;
